import { Component, OnInit } from '@angular/core';
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  NameRequired=false ; 
  EmailRequired = false ; 
  EmailInvalid = false ; 
  SubjectRequired  = false ; 
  messageRequired = false ; 
  constructor(private allUsers:UsersService) 
  {
    
   }
checkUser()
{
  if(this.allUsers.currentUser !== 0)
  {
    for(let user of this.allUsers.users)
    {
      if(user.id === this.allUsers.currentUser)
      {
        (<HTMLInputElement>document.getElementById("Name")).value = user.firstName +" "+ user.lastName ; 
        (<HTMLInputElement>document.getElementById("Email")).value = user.email  ; 
        break ;

      }
    }
  }
}
  ngOnInit() {
    this.checkUser();
  }

  checkMessage()
  {
    var name = (<HTMLInputElement>document.getElementById("Name")).value
    var mail = (<HTMLInputElement>document.getElementById("Email")).value
    var subject = (<HTMLInputElement>document.getElementById("Subject")).value
    var message = (<HTMLInputElement>document.getElementById("Message")).value
    var error = 0 

    if(name === "")
    {
      this.NameRequired = true ;
      error+=1 
    }
    else 
    {
      this.NameRequired = false 
    }
    if(mail === "")
    {
      this.EmailRequired = true ; 
      this.EmailInvalid = false 
      error+=1 
    }
    else if(mail.indexOf('@') === -1)
    {
      this.EmailRequired = false; 
      this.EmailInvalid = true  
      error+=1 
    }
    else 
    {
      this.EmailRequired = false; 
      this.EmailInvalid = false  
    }
    if(subject === "")
    {
      this.SubjectRequired  = true ; 
      error+=1 
    }
    else 
    {
      this.SubjectRequired = false 
    }
    if(message === "")
    {
      this.messageRequired = true ; 
      error+=1 
    }
    else
    {
      this.messageRequired = false ; 
    }

    if(error >0)
    {
      document.getElementById("contactForm").classList.add('animated', 'bounce')
      setTimeout(function(){
        document.getElementById('contactForm').classList.remove('bounce')
      },1000) ; 
    }
    else
    {
      (<HTMLFormElement>document.getElementById('contactForm')).reset();
      this.myFunction() 
    }
  }
   myFunction() {
    // Get the snackbar DIV
    var x = document.getElementById("snackbar");
  
    // Add the "show" class to DIV
    x.className = "show";
  
    // After 3 seconds, remove the show class from DIV
    setTimeout(function(){ document.getElementById("snackbar").className = x.className.replace("show", ""); }, 3000);
  }
  

}
